// pages/JreApproval.js
import React, { useState, useEffect } from 'react';
import { collection, getDoc, getDocs, doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import Layout from '../component/Layout';
// import { useNavigate } from 'react-router-dom';

const JreApproval = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending_verification'); // 'all', 'pending_verification', 'approved', 'rejected'
  const [updatingId, setUpdatingId] = useState(null);
  const operatorMobile = localStorage.getItem("operatorMobile");
  console.log(operatorMobile);
  // const navigate = useNavigate();

  // Fetch applications
  useEffect(() => {
    const fetchApplications = async () => {
      setLoading(true);
      try {
        // 1. Fetch all jreregistrations and keep doc ids whose operatorMobile matches
        const regSnapshot = await getDocs(collection(db, 'jreregistrations'));
        const matchingIds = [];
        regSnapshot.forEach(regDoc => {
          const mobile = regDoc.data().OpertorNumber?.toString().trim();
          if (mobile && mobile === operatorMobile?.toString().trim()) {
            matchingIds.push(regDoc.id);
          }
        });

        if (matchingIds.length === 0) {
          setApplications([]);
          return;
        }

        // 2. Fetch jredoc documents by those matching ids, filtered by status
        const apps = [];
        for (const id of matchingIds) {
          const regDoc = regSnapshot.docs.find(d => d.id === id);
          const fullName = regDoc ? regDoc.data().fullName : null;
          const jreDoc = await getDoc(doc(db, 'jredoc', id));
          if (!jreDoc.exists()) continue;
          const data = jreDoc.data();
          if (filter !== 'all' && data.status !== filter) continue;
          apps.push({ id: jreDoc.id, fullName, ...data });
        }
        setApplications(apps);
      } catch (error) {
        console.error('Error fetching applications:', error);
        alert('Failed to load applications');
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, [filter]);

  const handleApprove = async (id) => {
    if (updatingId) return;
    setUpdatingId(id);
    try {
      const docRef = doc(db, 'jredoc', id);
      await updateDoc(docRef, {
        status: 'approved',
        approvedAt: new Date()
      });
      const jreProfileRef = doc(db, 'profile', id);
      await setDoc(jreProfileRef, {
        jreDocs: true,
      }, { merge: true });
      // Optimistically update UI
      setApplications(prev =>
        prev.map(app => (app.id === id ? { ...app, status: 'approved' } : app))
      );
    } catch (error) {
      console.error('Approve failed:', error);
      alert('Failed to approve');
    } finally {
      setUpdatingId(null);
    }
  };

  const handleReject = async (id) => {
    if (updatingId) return;
    setUpdatingId(id);
    try {
      const docRef = doc(db, 'jredoc', id);
      await updateDoc(docRef, {
        status: 'rejected',
        rejectedAt: new Date()
      });
      setApplications(prev =>
        prev.map(app => (app.id === id ? { ...app, status: 'rejected' } : app))
      );
    } catch (error) {
      console.error('Reject failed:', error);
      alert('Failed to reject');
    } finally {
      setUpdatingId(null);
    }
  };

  const openImage = (url) => {
    if (url) window.open(url, '_blank');
  };

  return (

    <Layout pageTitle="JRE Approval" >
      <div style={styles.container}>
        <header style={styles.header}>
          <h1>👮 JRE Document Approval</h1>
          <div style={styles.filter}>
            <select value={filter} onChange={(e) => setFilter(e.target.value)} style={styles.select}>
              <option value="pending_verification">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="all">All</option>
            </select>
          </div>
        </header>

        {loading ? (
          <p style={styles.loading}>Loading applications...</p>
        ) : applications.length === 0 ? (
          <p style={styles.empty}>No applications found.</p>
        ) : (
          <div style={styles.grid}>
            {applications.map(app => (
              <div key={app.id} style={styles.card}>
                {console.log(app)}
                <div style={styles.cardHeader}>
                  <h3>JRE ID: {app.id}</h3>
                  <span style={{
                    ...styles.statusBadge,
                    backgroundColor:
                      app.status === 'approved' ? '#2ecc71' :
                        app.status === 'rejected' ? '#e74c3c' :
                          '#f39c12'
                  }}>
                    {app.status}
                  </span>

                </div>
                <h3 style={styles.infoRow}>Full Name :{app.fullName}</h3>
                <div style={styles.infoRow}>
                  <strong>Vehicle:</strong> {app.vehicle?.type} ({app.vehicle?.cc} CC)
                </div>
                <div style={styles.infoRow}>
                  <strong>Bank:</strong> {app.bank?.name} • {app.bank?.accountNumber}
                </div>
                <div style={styles.infoRow}>
                  <strong>Emergency:</strong> {app.emergency?.name} ({app.emergency?.relation})
                </div>

                {/* Document Previews */}
                <div style={styles.docsGrid}>
                  {[
                    { label: 'Aadhar Front', url: app.personal?.aadharFrontUrl },
                    { label: 'Aadhar Back', url: app.personal?.aadharBackUrl },
                    { label: 'PAN', url: app.personal?.panUrl },
                    { label: 'RC', url: app.vehicle?.rcUrl },
                    { label: 'DL', url: app.vehicle?.dlUrl },
                    { label: 'Insurance', url: app.vehicle?.insuranceUrl },
                    { label: 'Cancel Check', url: app.bank?.cancelCheckUrl },
                  ].map(doc => (
                    <div key={doc.label} style={styles.docItem}>
                      <small>{doc.label}</small>
                      {doc.url ? (
                        <img
                          src={doc.url}
                          alt={doc.label}
                          style={styles.docPreview}
                          onClick={() => openImage(doc.url)}
                        />
                      ) : (
                        <span style={styles.missing}>Missing</span>
                      )}
                    </div>
                  ))}
                </div>

                {/* Action Buttons */}
                {app.status === 'pending_verification' && (
                  <div style={styles.actions}>
                    <button
                      onClick={() => handleReject(app.id)}
                      disabled={updatingId === app.id}
                      style={styles.rejectButton}
                    >
                      {updatingId === app.id ? 'Processing...' : 'Reject'}
                    </button>
                    <button
                      onClick={() => handleApprove(app.id)}
                      disabled={updatingId === app.id}
                      style={styles.approveButton}
                    >
                      {updatingId === app.id ? 'Processing...' : 'Approve'}
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

const styles = {
  container: {
    padding: '1.5rem',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f5f7fa',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.5rem',
    padding: '0 0.5rem'
  },
  filter: {
    minWidth: '180px'
  },
  select: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    width: '100%'
  },
  loading: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#555'
  },
  empty: {
    textAlign: 'center',
    fontSize: '16px',
    color: '#888',
    marginTop: '2rem'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '1.5rem'
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    padding: '1rem',
    transition: 'box-shadow 0.2s'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.8rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #eee'
  },
  statusBadge: {
    color: 'white',
    padding: '4px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  infoRow: {
    fontSize: '14px',
    marginBottom: '0.4rem',
    color: '#333'
  },
  docsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '10px',
    margin: '1rem 0'
  },
  docItem: {
    textAlign: 'center'
  },
  docPreview: {
    width: '100%',
    height: '80px',
    objectFit: 'cover',
    borderRadius: '4px',
    border: '1px solid #eee',
    cursor: 'pointer',
    marginTop: '4px'
  },
  missing: {
    color: '#e74c3c',
    fontSize: '12px',
    fontStyle: 'italic'
  },
  actions: {
    display: 'flex',
    gap: '0.5rem',
    marginTop: '1rem'
  },
  approveButton: {
    flex: 1,
    padding: '8px',
    backgroundColor: '#2ecc71',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  rejectButton: {
    flex: 1,
    padding: '8px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};

export default JreApproval;